import Vue from 'vue';
import VuePlayerPlugin from 'vue-youtube-iframe-api';

Vue.use(VuePlayerPlugin);
